/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Add_Event_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to add the event to the league" |
*
* @param {League_Add_Event_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_add_event_error = /** @type {((inputs?: League_Add_Event_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Add_Event_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'ajout de l'événement à la ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al añadir el evento a la liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao adicionar o evento à liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiungere l'evento al campionato")
	return /** @type {LocalizedString} */ ("Failed to add the event to the league")
});